import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Eye } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import PlanogramEditor from "./PlanogramEditor";

export default function Planogram() {
  const [kiosks, setKiosks] = useState([]);
  const [kioskId, setKioskId] = useState("");
  useEffect(() => { api.get("/kiosks").then((r) => { setKiosks(r.data); if (r.data.length) setKioskId(r.data[0].id); }); }, []);

  return (
    <div className="p-6 lg:p-8 space-y-6">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <h1 className="font-admin-head text-2xl sm:text-3xl font-bold text-slate-900 dark:text-white">Planograms</h1>
          <p className="text-slate-500 mt-1">Lay out each kiosk’s units, shelves and products. <b>The planogram order is exactly what customers see on the kiosk.</b></p>
        </div>
        <div className="flex items-center gap-2">
          <Select value={kioskId} onValueChange={setKioskId}>
            <SelectTrigger data-testid="plano-kiosk-select" className="w-56"><SelectValue placeholder="Select kiosk" /></SelectTrigger>
            <SelectContent>{kiosks.map((k) => <SelectItem key={k.id} value={k.id}>{k.name} ({k.code})</SelectItem>)}</SelectContent>
          </Select>
          <Button
            data-testid="plano-open-preview"
            variant="outline"
            onClick={() => window.open(`/admin/kiosk-preview?kiosk=${kioskId}`, "_blank")}
            disabled={!kioskId}
          ><Eye className="h-4 w-4 mr-1.5" /> Customer preview</Button>
        </div>
      </div>

      {!kiosks.length && <p className="text-slate-400 text-sm">No kiosks yet. Add one in Sites &amp; Kiosks first.</p>}
      {kioskId && <PlanogramEditor kioskId={kioskId} />}
    </div>
  );
}
